import type { Dictionary } from 'lodash';
import { AlgoliaConfig } from './AlgoliaDevicePicker';
import isIE from './utils/isIE';

export type Hierarchy = { [title: string]: Hierarchy } | null;

export interface Wiki {
   title: string;
   display_title: string;
   summary: string;
   image: string;
}

export enum View {
   Grid = 'GRID',
   Column = 'COLUMN',
}

export type State = 'category' | 'search';
export type SearchState = 'inactive' | 'pending' | 'no_results';

// enum for the state of the user's search
// INACTIVE is before searching, or after a successful search.
export const SEARCH_INACTIVE = 'inactive';
// PENDING is during the 500ms debounce before actually performing a search.
export const SEARCH_PENDING = 'pending';
// NO_RESULTS is when the search is completed, but didn't find a result.
export const SEARCH_NO_RESULTS = 'no_results';

export const HIDE_GRID_VIEW = isIE();

export type DevicePickerContextType = {
   state: State;
   query: string;
   category: string;
   hierarchy?: Hierarchy;
   displayTitles?: Dictionary<string>;
   leaves: Set<string> | null;
   path: string[];
   searchState: SearchState;
   view: View;
   loaded: boolean;
   setState: (state: State) => void;
   setQuery: (query: string) => void;
   setCategory: (category: string) => void;
   setPath: (path: string[]) => void;
   setSearchState: (search: SearchState) => void;
   setView: (view: View) => void;
   setLoaded: (loaded: boolean) => void;
   updateCategory: (category?: string) => void;
   isUncategorized: (category?: string) => boolean;
};

export interface DevicePickerProps {
   fetchHierarchy: () => Promise<{
      hierarchy: Hierarchy;
      display_titles: Dictionary<string>;
   }>;
   fetchChildren: (title: string) => Promise<Array<Wiki>>;
   onSubmit: (title: string) => void;
   onCancel: () => void;
   allowOrphan?: boolean;
   initialDevice?: string;
   initialView?: View;
   objectName?: string;
   algoliaConfig?: AlgoliaConfig;
   onSearch?: (value: string) => void;
}
